import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Constants } from 'src/app/models/constants';
import { TableHeader } from 'src/app/models/tableheader.model';
export class OrderByTableHeader {
  column: string = '';
  orientation: string = '';
}
@Component({
  selector: 'app-table-header-new',
  templateUrl: './table-header-new.component.html',
  styleUrls: ['./table-header-new.component.scss'],
})
export class TableHeaderNewComponent implements OnInit {
  //--------------------Inputs & Outputs--------------------
  @Input() tableHeader!: TableHeader[]; // Listado de columnas
  @Input() orderByColumnDefault?: TableHeader; // Definir columna seleccionada por default
  @Input() isCheckboxColumnVisible?: boolean = false; // Mostrar/ocultar checkbox
  @Input() isStickyEnabled?: boolean = true;
  @Input() isCheckboxChecked: boolean = false;
  @Input() isDisabled?: boolean = false;
  @Output() checkboxChange: EventEmitter<MatCheckboxChange> =
    new EventEmitter<MatCheckboxChange>();
  @Output() orderByChange: EventEmitter<OrderByTableHeader> =
    new EventEmitter<OrderByTableHeader>();
  @Input() orderByOrientationDefault: string = 'ASC';

  //--------------------ViewChild--------------------
  @ViewChild('tableHeaderElement') tableHeaderElement!: ElementRef;

  //--------------------Variables--------------------
  isTableHeaderSticky: boolean = false;
  tableHeaderPosition: number = 0;
  orderByColumn: string = ''; // Define cual es la columna seleccionada
  orderByOrientation: string = '';

  public readonly ICON_ARROW_UP = Constants.ICONS.ARROW_NORTH;

  get hasSubLabels(): boolean {
    return this.tableHeader?.some((item) => !!item.subLabel) ?? false;
  }

  handleScroll(): void {
    if (this.isStickyEnabled) {
      this.calculateTableHeaderPosition();
      const windowScroll = window.pageYOffset;
      this.isTableHeaderSticky = false;

      if (windowScroll >= this.tableHeaderPosition) {
        this.isTableHeaderSticky = true;
      }
    }
  }

  ngOnInit(): void {
    this.isTableHeaderSticky = false;
    this.setOrderColumns();
  }

  ngOnChanges() {
    this.setOrderColumns();
  }

  setOrderColumns(): void {
    if (this.orderByColumnDefault?.id)
      this.orderByColumn = this.orderByColumnDefault.id;
    this.orderByOrientation = this.orderByOrientationDefault;
  }

  calculateTableHeaderPosition(): void {
    this.tableHeaderPosition =
      this.tableHeaderElement?.nativeElement.offsetTop -
      this.tableHeaderElement?.nativeElement.offsetHeight -
      32;
  }

  orderBy(itemTH: any): void {
    if (!itemTH.isOrderByVisible) return;
    let column = itemTH.id;

    this.orderByColumn = column;
    if (this.orderByOrientation == 'ASC') {
      this.orderByOrientation = 'DES';
    } else if (this.orderByOrientation == 'DES') {
      this.orderByOrientation = 'ASC';
    }

    this.orderByChange.emit({
      column: this.orderByColumn,
      orientation: this.orderByOrientation,
    });
  }

  toggleCheckboxChange(e: MatCheckboxChange): void {
    this.checkboxChange.emit(e);
  }
}
